import { render } from "./NvLogo.vue?vue&type=template&id=d179f0c4"
import script from "./NvLogo.vue?vue&type=script&lang=js"
export * from "./NvLogo.vue?vue&type=script&lang=js"

import "./NvLogo.vue?vue&type=style&index=0&id=d179f0c4&lang=css"

import exportComponent from "/working_dir/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__